import {
  DISCLAIMER,
  EMAIL,
  COMMENTS,
  CONTACT_CONFIRMATION,
  selectContactHomebotStep,
} from '../../../../../../../store/slices/contactHomebot'
import { Disclaimer } from './Disclaimer'
import { Email } from './Email'
import { Comments } from './Comments'
import { ContactConfirmation } from './ContactConfirmation'
import { useSelector } from 'react-redux'

export const ContactHomebotModalSteps = () => {
  const currentStep = useSelector(selectContactHomebotStep)

  return (
    <>
      {currentStep === DISCLAIMER && <Disclaimer />}
      {currentStep === EMAIL && <Email />}
      {currentStep === COMMENTS && <Comments />}
      {currentStep === CONTACT_CONFIRMATION && <ContactConfirmation />}
    </>
  )
}
